import { useTranslation } from 'next-i18next';

import React from 'react';

import { Box, Button, Flex, Heading, Link, Text } from '@chakra-ui/react';

import { Media } from '@nocowanie/common-ui';
import { IconsLinear, IconsTwoTone } from '@nocowanie/icons';

export const EmptyCheckoutBox = () => {
    const { t } = useTranslation('checkout');

    return (
        <>
            <Media
                image={<IconsTwoTone.BagCross size={'4xl'} duoToneColor={'brand.solid'} />}
                gap={8}
                mb={8}
                breakOn={'md'}
                textAlign={{
                    base: 'center',
                    md: 'left',
                }}
            >
                <Heading as={'p'} size={'md'} mb={6}>
                    {t('emptyCheckout.noRoomAddedHeader')}
                </Heading>
                <Text mb={6}>{t('emptyCheckout.noRoomAddedDescription')}</Text>
                <Button
                    asChild
                    variant={'solid'}
                    w={{
                        base: '100%',
                        md: 'auto',
                    }}
                >
                    <a href={'/'}>{t('emptyCheckout.noRoomAddedButton')}</a>
                </Button>
            </Media>

            <Flex
                flexWrap={'wrap'}
                gap={6}
                alignItems={'center'}
                bg={'secondary.50'}
                p={4}
                borderRadius={'md'}
                textAlign={{
                    base: 'center',
                    md: 'left',
                }}
                justifyContent={{
                    base: 'center',
                    md: 'start',
                }}
            >
                <Box>
                    <Text fontWeight={'bold'}>{t('helpBox.header')}</Text>
                    <Text>{t('helpBox.text')}</Text>
                </Box>
                <Media
                    image={<IconsLinear.UserTick size={'xl'} color={'gray.800'} />}
                    bodyTextAlign={'left'}
                    bodyVerticalAlign={'center'}
                >
                    <Link href={'tel:801000781'} colorPalette={'gray'} variant={'plain'}>
                        801 000 781
                    </Link>
                </Media>
            </Flex>
        </>
    );
};
